import { styled } from "@mui/material/styles";
import { Card, Tab, TableCell } from "@mui/material";
import { useColors } from "../../Context/ColorsContext"
import { CustomTabs } from "../styles";


export const CustomCard = styled(Card)(() => ({
  minHeight: 430,
  maxHeight: "calc(100vh - 100px)",
  width: "100%",
  borderRadius: 6,
  boxShadow: "rgb(61 71 82 / 20%) 0px 4px 8px",
  padding: "30px 20px",
}));

export const SectionPageTitle = styled("section")(() => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
}));

export const PageSubtitle = styled("p")(({ theme }) => ({
  color: '#949ba5',
  fontSize: 14,
  [theme.breakpoints.down('md')]: {
    fontSize: 12
  }
}));

export const CustomTableCell = styled(TableCell)(() => {
  const { colors } = useColors();
  return {
    color: colors.main,
    fontSize: "12px",
    fontWeight: 600,
  }
});


export const TableCellStatus = styled(TableCell)(() => ({
  display: "flex",
}));
export const ContainerCell = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
}));

export const SectionInfo = styled("section")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const InfoCell = styled("div")(() => ({}));

export const Spacer = styled("div")(() => ({
  display: "flex",
  flex: 1,
}));

export const SettingsTabs = styled(CustomTabs)(() => {
	return {
    borderRadius: '16px',
	}
});

export const SettingsTab = styled(Tab)(({ selected }) => {
  const { colors } = useColors();
	return {
		background: selected ? colors.sidebarSelectColor : colors.white,
		borderRadius: '16px',
		padding: '0px 2rem !important',
		color: selected ? `${colors.buttonActionColor} !important` : '#383838 !important',
		fontWeight: selected ? 'bold !important' : 'inherit',
		'& .MuiSvgIcon-root': {
			fontSize: '1.2rem !important'
		}
	}
});

export const ContentCard = styled(Card)(() => ({
	borderRadius: '16px',
	border: "1px solid #e0e0e0",
	boxShadow: "none",
	padding: "1rem",
}));
